import { FormActivationBcaVaData } from './types';

export enum VaType {
  CloseAmount = 'close_amount',
  OpenAmount = 'open_amount',
}

export const DEFAULT_VALUE: FormActivationBcaVaData = {
  companyName: '',
  brandName: '',
  businessAddress: '',
  businessAddressCity: '',
  businessAddressDistrict: '',
  businessAddressPostalCode: '',
  businessAddressProvince: '',
  businessAddressSubDistrict: '',
  businessEstablishedDate: '',
  businessIndustry: '',
  businessLink: '',
  businessTaxpayerId: '',
  picEmail: '',
  picName: '',
  picPhoneNumber: '',
  picPosition: '',
  accountName: '',
  accountNumber: '',
  vaType: [],
};

export const MAX_STEPS = 4;

export const VA_TYPE_OPTIONS = [
  {
    label: 'VA Open Amount',
    value: VaType.OpenAmount,
  },
  {
    label: 'VA Close Amount',
    value: VaType.CloseAmount,
  },
];

export const formTitle = (step: number) => {
  switch (step) {
    case 1:
      return 'common_businessInformation';
    case 2:
      return 'common_picInformation';
    case 3:
      return 'formActivationBcaVa_businessTransaction_title';
    default:
      return '';
  }
};
